import React from 'react';
import ProfileCard from './components/ProfileCard';

function App() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] py-8 px-4">
      <ProfileCard />
    </div>
  );
}

export default App;
